module.exports = {
  credentialActivated: 'Credential activated successfully',
  credentialDeactivated: 'Credential deactivated successfully',
  credentialCreated: 'Credential created successfully',
  credentialUpdated: 'Credential updated successfully',
  skillRemoved: 'Skill removed',
  skillAttached: 'Skill attached',
  cronActivated: 'Cron activated successfully',
  cronDeactivated: 'Cron deactivated successfully',
  cronCreated: 'Cron created successfully',
  cronUpdated: 'Cron updated successfully',
  agentActivated: 'Agent activated successfully',
  agentDeactivated: 'Agent deactivated successfully',
  agentCreated: 'Agent created successfully',
  agentUpdated: 'Agent updated successfully',
  restActivated: 'Rest activated successfully',
  restDeactivated: 'Rest deactivated successfully',
  restCreated: 'Rest created successfully',
  restUpdated: 'Rest updated successfully',
  processActivated: 'Process activated successfully',
  processDeactivated: 'Process deactivated successfully',
  processCreated: 'Process created successfully',
  processUpdated: 'Process updated successfully',
  copiedClipboard: 'Copied to clipboard',
  userActivated: 'User activated successfully',
  userDeactivated: 'User deactivated successfully',
  userCreated: 'User created successfully',
  userUpdated: 'User updated successfully',
  roleCreated: 'Role created successfully',
  roleUpdated: 'Role updated successfully',
  tagCreated: 'Tag created successfully',
  tagUpdated: 'Tag updated successfully',
  test: 'Test Successful',
  templateCreated: 'Template created successfully',
  templateUpdated: 'Template updated successfully',
  translationCreated: 'Translation created successfully',
  translationUpdated: 'Translation updated successfully',
  translationDeleted: 'Translation deleted successfully',
  resendPassword: 'Password reset instructions sent successfully',
  settingActivated: 'Setting activated successfully',
  settingDeactivated: 'Setting deactivated successfully',
  settingCreated: 'Setting created successfully',
  settingUpdated: 'Setting updated successfully',
  stepCopy: 'Step copied successfully',
  cronExecute: 'Cron execute successful with Event ID:',
  restUrlCheckIsExist: 'Check successful, URL exists on trigger ID:',
  restUrlCheckNoExist: 'Check successful, URL doesn\'t exists',
  moduleCreated: 'Module created successfully',
  moduleUpdated: 'Module updated successfully',
  moduleExport: 'Module exported successfully',
  moduleImport: 'Module imported successfully',
  moduleValidate: 'Module validated successfully',
  validationCreated: 'Validation rule created successfully',
  validationUpdated: 'Validation rule updated successfully',
  apiKeyGeneration: 'ApiKey generated successfully',
  moduleUploaded: 'Module uploaded successfully',
  moduleDownloaded: 'Module downloaded successfully',
  moduleInstalled: 'Module installed successfully',
  pluginActivated: 'Plugin activated successfully',
  pluginDeactivated: 'Plugin deactivated successfully',
  pluginCreated: 'Plugin created successfully',
  pluginUpdated: 'Plugin updated successfully',
  pluginImport: 'Plugin imported successfully',
  reviewSubmit: 'Review submitted successfully',
  userSettingsSubmit: 'User settings submitted successfully',
  passwordReset: 'Password reset email sent successfully',
  passwordSet: 'Password set successfully',
  messagingActivated: 'Messaging activated successfully',
  messagingDeactivated: 'Messaging deactivated successfully',
  messagingUpdated: 'Messaging updated successfully',
  messagingCreated: 'Messaging created successfully',
  libraryActivated: 'Library activated successfully',
  libraryDeactivated: 'Library deactivated successfully',
  libraryUpdated: 'Library updated successfully',
  libraryCreated: 'Library created successfully',
  libraryUploaded: 'Library uploaded successfully',
  passwordChanged: 'Password changed successfully',
  storageUpdated: 'Storage updated successfully',
  storageCreated: 'Storage created successfully',
  eventHandlerActivated: 'Event Handler activated successfully',
  eventHandlerDeactivated: 'Event Handler deactivated successfully',
  eventHandlerUpdated: 'Event Handler updated successfully',
  eventHandlerCreated: 'Event Handler created successfully',
  entityActivated: 'Entity activated successfully',
  entityDeactivated: 'Entity deactivated successfully',
  entityCreated: 'Entity created successfully',
  entityUpdated: 'Entity updated successfully',
  entityGenerated: 'Entity generated successfully',
  staticResourceCreated: 'Static resource created successfully',
  staticResourceUpdated: 'Static resource updated successfully',
  staticResourceActivated: 'Static resource activated successfully',
  staticResourceDeactivated: 'Static resource deactivated successfully',
  staticResourceUploaded: 'Static resource uploaded successfully',
  staticResourceDownoaded: 'Static resource downloaded successfully',
  twoFactorAuthEnabled: 'Two Factor Authentication enabled',
  twoFactorAuthDisabled: 'Two Factor Authentication disabled',
  interruptEventsSuccess: 'Interrupt events successful',
  failedAttemptsReset: 'Failed attempts reset successfully',
  downloadSuccess: 'Download successful',
  mfaStartingDateUpdated: 'MFA starting date updated successfully',
  staticResourceFileRestoredFromHistory: 'Static resource file restored from history successfully',
  flushAllSuccess: 'Cache flushed successfully for all cache types.',
  flushTypeSuccess: 'Cache flushed successfully for cache type:',
  mcpUpdated: 'MCP updated successfully',
  mcpCreated: 'MCP created successfully',
  mcpActivated: 'MCP activated successfully',
  mcpDeactivated: 'MCP deactivated successfully',
  screenCreated: 'Screen created successfully',
  screenUpdated: 'Screen updated successfully',
  screenActivated: 'Screen activated successfully',
  screenDeactivated: 'Screen deactivated successfully',
  tenantActivated: 'Tenant activated successfully',
  tenantDeactivated: 'Tenant deactivated successfully',
  tenantUpdated: 'Tenant updated successfully',
  tenantCreated: 'Tenant created successfully',
  uiTriggerActivated: 'UI Trigger activated successfully',
  uiTriggerDeactivated: 'UI Trigger deactivated successfully',
  uiTriggerCreated: 'UI Trigger created successfully',
  uiTriggerUpdated: 'UI Trigger updated successfully',
  flowActivated: 'Flow activated successfully',
  flowDeactivated: 'Flow deactivated successfully',
  flowCreated: 'Flow created successfully',
  flowUpdated: 'Flow updated successfully',
  flowDeleted: 'Flow deleted successfully',
  tenantUserCreated: 'Tenant user created successfully',
  tenantUserActivated: 'Tenant user activated successfully',
  tenantUserDeactivated: 'Tenant user deactivated successfully',
  whatsappCreated: 'WhatsApp trigger created successfully',
  whatsappUpdated: 'WhatsApp trigger updated successfully',
  whatsappActivated: 'WhatsApp trigger activated',
  whatsappDeactivated: 'WhatsApp trigger deactivated',
  applicationActivated: 'Application activated successfully',
  applicationDeactivated: 'Application deactivated successfully',
  applicationCreated: 'Application created successfully',
  applicationUpdated: 'Application updated successfully',
  containerStarted: 'Container started successfully',
  containerPaused: 'Container paused successfully',
  containerStopped: 'Container stopped successfully',
  fileUploaded: 'File uploaded successfully',
  fileDeleted: 'File deleted successfully',
  gitPullCompleted: 'Pull completed',
  gitPushCompleted: 'Push completed',
  gitCloneCompleted: 'Repository cloned',
  gitCheckoutCompleted: 'Branch checked out',
  gitStageAllCompleted: 'All changes staged',
  gitCommitCompleted: 'Commit created',
  gitRefreshCompleted: 'Git state refreshed',
  gitStagePathCompleted: 'Path staged',
  gitUnstagePathCompleted: 'Path unstaged'
}
